module.exports = __webpack_public_path__ + "static/img/10012 (4).eeb2f6e.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10012 (4).webp
// module id = 3ZoG
// module chunks = 14